import { CenterSlot } from "./CenterSlot";
import { HeaderWrapperRoot } from "./HeaderWrapperRoot";
import { LeftSlot } from "./LeftSlot";
import { RightSlot } from "./RightSlot";

export const HeaderWrapper = Object.assign(HeaderWrapperRoot, {
  LeftSlot,
  CenterSlot,
  RightSlot,
});
